<template>
  <div class="vg_wrapper">
    <el-card>
      <div class="flexV vg_mb_8">
        通知时间:
        <el-date-picker
          v-model="dateRange"
          class="vg_ml_8 vg_mr_8"
          end-placeholder="结束日期"
          range-separator="至"
          size="small"
          start-placeholder="开始日期"
          style="width: 300px"
          type="daterange"
          value-format="timestamp"
        />
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList()">查询</el-button>
        <el-button icon="el-icon-refresh-right" size="small" type="info" @click="buttonRefresh()"> 刷新</el-button>
      </div>
      <SearchTable
        ref="multiTable"
        v-loading="loadFlag"
        :columns="c_tableProperties"
        :data="tableData"
        :needPagination="false"
        :tableRowKey="'id'"
        :totalPage="totalPage"
        @getTableData="getDataList"
      >
        <template v-slot:operation="scope">
          <div style="display: flex">
            <el-button :disabled="scope.row.status.indexOf('已回传') !== -1" size="mini" type="primary" @click="showDialog(scope.row)"
              >上传</el-button
            >
            <el-button
              :disabled="scope.row.status.indexOf('已回传') !== -1"
              size="mini"
              type="warning"
              @click="returnTransmission(scope.row)"
              >回传
            </el-button>
          </div>
        </template>
      </SearchTable>
      <el-dialog
        :visible.sync="dialogVisible"
        title="相关文档"
        width="55%"
        @close="getDataList"
        @opened="
          $nextTick(() => {
            $refs.docuAbout.initData();
          })
        "
      >
        <docu-about ref="docuAbout" :addFlag="status" :delFlag="status" :form_id="currentRow.consultations_id"></docu-about>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import SearchTable from '@/components/SearchTableV3.vue';
import { tableProperties } from '@/views/PurchaseManagement/OverseasConsultationForm/js/properties';
import { api } from '@/views/PurchaseManagement/OverseasConsultationForm/js/api';
import DocuAbout from '@/views/PurchaseManagement/OverseasConsultationForm/docuAbout';
import { setTime } from '@api/public';

export default {
  name: 'OverseasConsultationFormList',
  components: {
    SearchTable,
    DocuAbout
  },
  data() {
    return {
      tableProperties: cloneDeep(tableProperties),
      tableData: [],
      totalPage: 0,
      btn: {},
      loadFlag: false,
      currentRow: {},
      dateRange: [],
      dialogVisible: false
    };
  },
  computed: {
    c_tableProperties() {
      return this.tableProperties;
    },
    status() {
      return this.currentRow.status !== '已上传已回传';
    }
  },
  mounted() {
    this.$nextTick(() => {
      let searchForm = this.$refs.multiTable.searchForm;
      searchForm.sampling_order_number = this.$route.query.sampling_order_number;
      searchForm.prod_name = this.$route.query.prod_name;
      this.initData();
    });
  },
  methods: {
    initData() {
      this.getDataList();
    },
    getDataList() {
      this.loadFlag = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      let deptName = this.$cookies.get('userInfo').dept_name;
      if (deptName === '扬州打样间' || deptName === '上海打样间') searchForm.sampling_department = deptName;
      else searchForm.sampling_department = null;
      setTime(searchForm, 'startTime', 'endTime', this.dateRange || [], true);
      api.getConsultationsList(searchForm).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.btn = data.btn;
        this.loadFlag = false;
      });
    },
    // 刷新
    buttonRefresh() {
      this.dateRange = [];
      this.$refs.multiTable.resetFields();
      this.getDataList();
    },
    // 显示弹窗
    showDialog(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    // 回传
    returnTransmission(row) {
      api.back_to_ems({ consultations_id: row.consultations_id }).then(({ data }) => {
        this.$message({
          message: '回传成功',
          type: 'success'
        });
        this.getDataList();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
